'use strict';

var Reflux = require('reflux');
var router = require('routers/main');

/* Actions */
var TeamActions = require('actions/team');

/* API */
var TeamApi = require('api/team');

/* Stores */
var TeamStore = Reflux.createStore({

  listenables: [TeamActions],

  init: function init() {
    var store = this;

    store.loading = true;
    store.teams = [];
  },

  getInitialState: function getInitialState() {
    return this.teams;
  },

  onLoadAll: function onLoadAll() {
    var _this = this;

    TeamApi.load().done(function (teams) {
      _this.teams = teams;
      _this.loading = false;
      _this.trigger(_this.teams);
    });
  },

  onCreate: function onCreate(props) {
    var _this2 = this;

    TeamApi.add(props).done(function (team) {
      _this2.teams.unshift(team);
      _this2.trigger(_this2.teams);
    });
  },

  onDelete: function onDelete(id) {
    var _this3 = this;

    router.transitionTo('/');

    TeamApi['delete'](id).done(function () {
      _this3.teams = _this3.teams.filter(function (team) {
        return team.id !== id;
      });
      _this3.trigger(_this3.teams);
    });
  },

  onSubmit: function onSubmit(id, props) {
    var _this4 = this;

    router.transitionTo('/');

    TeamApi.update(id, props).done(function (newTeam) {
      // Exchange the new team for the old team
      _this4.teams = _this4.teams.map(function (team) {
        return team.id === id ? newTeam : team;
      });
      _this4.trigger(_this4.teams);
    });
  },

  onAssignUser: function onAssignUser(teamId, userId) {
    var store = this;
    var teams = store.teams;

    var team = teams.find(function (team) {
      return team.id === teamId;
    });
    var users = team.users;

    if (team.users.some(function (user) {
      return user.userId === userId;
    })) {
      return;
    }

    var user = { userId: userId, role: 'reviewer' };
    users.push(user);

    TeamApi.update(teamId, { users: users });

    store.trigger(teams);
  },

  onUnassignUser: function onUnassignUser(teamId, userId) {
    var store = this;
    var teams = store.teams;

    var team = teams.find(function (team) {
      return team.id === teamId;
    });

    if (!team.users.some(function (user) {
      return user.userId === userId;
    })) {
      return;
    }

    team.users = team.users.filter(function (user) {
      return user.userId !== userId;
    });

    TeamApi.update(teamId, { users: team.users });

    store.trigger(teams);
  },

  onAssignTeam: function onAssignTeam(projectId, teamId) {
    var store = this;
    var teams = store.teams;

    var team = teams.find(function (team) {
      return team.id === teamId;
    });

    team.projects.push(projectId);

    store.trigger(teams);
  },

  onAssignDatasource: function onAssignDatasource(catalogueId, teamId) {
    var store = this;
    var teams = store.teams;

    var team = teams.find(function (team) {
      return team.id === teamId;
    });

    team.catalogues.push(catalogueId);

    store.trigger(teams);
  },

  onChangeUserRole: function onChangeUserRole(teamId, userId, role) {
    var store = this;
    var teams = store.teams;

    var team = teams.find(function (team) {
      return team.id === teamId;
    });

    var user = team.users.find(function (user) {
      return user.id === userId;
    });

    user.role = role;

    store.trigger(teams);
  }
});

module.exports = TeamStore;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/stores/team.js
 **/